import { useMemo } from "react";
import {
  HelpContent,
  Product,
} from "../../../../application/domain/help/help-entity";
import { CategoryObjectIds } from "../../../../application/domain/help/const";
import React from "react";
import { CategoryProps } from "./category";

type ProductBoxContent = {
  product: Product;
  contentList: HelpContent[];
};

export type ProductBoxProps = {
  data: ProductBoxContent;
};

export type ProductSearchFunctionProps = CategoryProps & {
  productList: Product[];
};

export const useProductSearchFunctionController = ({
  categoryList,
  productList,
}: ProductSearchFunctionProps) => {
  const category = React.useMemo(() => {
    return categoryList.find(
      (category) => category.id === CategoryObjectIds.SEARCH_FUNCTION_OBJECT_ID,
    );
  }, [categoryList]);
  const contentList: ProductBoxContent[] = useMemo(() => {
    return productList.map((product) => {
      const productContents: HelpContent[] = [];
      category?.metadata.children.forEach((child) => {
        if (child.metadata.product.id === product.id) {
          productContents.push(child);
        }
      });
      return { product, contentList: productContents };
    });
  }, [category, productList]);

  return {
    contentList,
    category,
  };
};
